export default __webpack_public_path__ + "static/media/screw-machine.34d214d0.svg";